<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
        <h6 class="element-header mb-3 mb-sm-4">
          {{ $t('course.general_title') }}
        </h6>

        <div class="d-grid d-sm-block">
          <CreateButton
              @click="handlePriceModalForm()"
              :label="$t('course.assisted_living_coaching.create')">
          </CreateButton>
        </div>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          {{ $t('course.assisted_living_coaching.list') }}
        </h5>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getPriceList"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>{{ $t('general.start_from') }}</th>
              <th>{{ $t('general.valid_till') }}</th>
              <th>{{ $t('general.price') }}</th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(price) in priceList.data" :key="price.id">
              <td>{{ price?.startFrom }}</td>
              <td>{{ price?.validTill }}</td>
              <td>{{ price?.price }}</td>
              <td class="text-right">
                <button class="btn btn-primary"
                        @click="handlePriceModalForm(price.id)">
                  <i class="os-icon os-icon-edit"></i>
                </button>
                <button class="btn btn-danger ml-2"
                        @click="handleModalDelete(price?.id)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="priceList?.pagination?.total_pages > 1"
            :totalPages="priceList?.pagination?.total_pages"
            :currentPage="priceList?.pagination?.current_page"
            :totalItems="priceList?.pagination?.total_items"
            :perPage="priceList?.pagination?.items_per_page"
            @pagechanged="getPriceList"/>
      </div>
    </div>

    <Modal
        v-model="showPriceFormModal"
        :title="$t('course.assisted_living_coaching.title')"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        :customWidth="'600px'"
        :hide-footer="true"
        classFooter="justify-content-center">
      <PriceForm
          :priceId="priceId"
          v-model:submitForm="submitForm"/>
    </Modal>

    <ModalDelete
        v-model="showDeleteModal"
        :header="t('general.delete_item_header')"
        :onDelete="deletePrice">
    </ModalDelete>

  </PageTemplate>
</template>


<script setup>
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import courseAssistedLivingCoachingService from "@/api/Course/AssistedLivingCoaching";
import Modal from "@/components/modal/Modal.vue";
import PriceForm from "@/views/App/Course/AssistedLivingCoaching/PriceForm.vue";

const {t} = useI18n();
const priceList = ref([]);
const isLoaded = ref(false);
const priceId = ref(null)
const showPriceFormModal = ref(false);
const showDeleteModal = ref(false)
const submitForm = ref(false);

watch(submitForm, () => {
  priceId.value = null;
  showPriceFormModal.value = false;
  showDeleteModal.value = false;
  getPriceList();
});

async function getPriceList(page = 1, perPage) {
  CloseToast();

  const perPageRes = priceList.value?.pagination?.items_per_page;

  try {
    const {data} = await courseAssistedLivingCoachingService.getPriceList({
      page: page,
      limit: perPage ?? perPageRes,
    });

    priceList.value = data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function deletePrice() {
  try {
    await courseAssistedLivingCoachingService.deletePrice(+priceId.value);

    priceId.value = null;
    showDeleteModal.value = false;

    await getPriceList();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}


function handlePriceModalForm(id = null) {
  CloseToast()
  priceId.value = id;
  showPriceFormModal.value = true;
  showDeleteModal.value = false;
}

function handleModalDelete(id) {
  CloseToast()
  priceId.value = id;
  showDeleteModal.value = true;
  showPriceFormModal.value = false;
}

onMounted(async () => {
  await Promise.all([
    getPriceList()
  ]);

  isLoaded.value = true;
});
</script>

<style scoped>

</style>